// Safe localStorage wrappers — silently no-op when storage is blocked
// (private browsing, quota exceeded, browser policy).

export function lsGet(key, fallback = null) {
  try { return localStorage.getItem(key) ?? fallback; } catch { return fallback; }
}

export function lsSet(key, value) {
  try { localStorage.setItem(key, String(value)); } catch { /* storage blocked */ }
}

export function lsRemove(key) {
  try { localStorage.removeItem(key); } catch { /* storage blocked */ }
}

// ── Guest reading progress ─────────────────────────────────────────────────
// Stores the last poem and verse a guest user was reading.
// Keyed by poemId so multiple in-progress poems can be tracked.
// Device-local only — does not sync across devices.

export function guestSaveProgress(poemId, poemTitleAr, poetAr, verseIdx, totalVerses) {
  try {
    const existing = guestGetAllProgress();
    existing[poemId] = {
      poemId,
      poemTitleAr,
      poetAr,
      verseIdx,
      totalVerses,
      savedAt: new Date().toISOString(),
    };
    localStorage.setItem('diwanGuestProgress', JSON.stringify(existing));
  } catch { /* non-fatal */ }
}

export function guestGetAllProgress() {
  try {
    const raw = localStorage.getItem('diwanGuestProgress');
    return raw ? JSON.parse(raw) : {};
  } catch { return {}; }
}

export function guestGetLatestProgress() {
  try {
    const all = guestGetAllProgress();
    const entries = Object.values(all);
    if (!entries.length) return null;
    // Return the most recently saved entry
    return entries.sort((a, b) =>
      new Date(b.savedAt) - new Date(a.savedAt)
    )[0];
  } catch { return null; }
}
